export enum ProductTaxType {
    VATABLE = 'vatable',
    VAT_EXEMPT = 'vat_exempt',
    ZERO_RATED = 'zero_rated'
}